import { ApiService } from 'src/app/services/api.service';
import { Injectable } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { BsModalService } from "ngx-bootstrap/modal";
import { BehaviorSubject, lastValueFrom, map, Observable, of, shareReplay, Subject } from "rxjs";
import Swal, { SweetAlertOptions, SweetAlertResult } from "sweetalert2";
// import { ModalPopupComponent } from "../components/bussinesspages/user-management/modal-popup/modal-popup.component";
// import { CandidateFilterTemplateComponent } from "../components/candidate-module/candidate-filter-template/candidate-filter-template.component";
// import { JobFilterTemplateComponent } from "../components/job-module/job-filter-template/job-filter-template.component";
import { GigsumoConstants } from "./GigsumoConstants";
import * as $ from 'jquery';

export function pauseForSeconds(sec:number) {
  return new Promise(resolve => {
      setTimeout(() => {
          resolve("complete");
      }, sec);
  });
}

export interface superAdminDetails {
  organisationId: string,
  userId: string,
  call: boolean,
  status: "CALL" | "NOCALL"
}


export const MODAL_OPTIONS: any = {
  backdrop: 'static',
  keyboard: false,
  size: "lg",
};

export type CUSTOMER_MENU_ITEMS = "plan" | "user" | "interaction" | "jobs" | "workSpace" |
    "businessNetworks" | "businessContacts" | "network" | "contacts" | "analytics" | "billing";





export type APPLICANT_STATUS =
"CANDIDATE-SELECTED" |
"PROFILE-REJECTED" |
"ONBOARDED" |
"PREONBOARDED" |
"INTERVIEW-SCHEDULED" |
"INTERVIEW SCHEDULED" |
"L1-INTERVIEW" |
"L2-INTERVIEW" |
"L3-INTERVIEW" |
"L1 INTERVIEW" |
"L2 INTERVIEW" |
"L3 INTERVIEW" |
"CANDIDATE-SHORTLISTED" |
"SHORTLISTED" |
"PRE-ONBOARDED" |
"OFFER-WITHDRAWN" |
"WITHDRAW" |
"OFFER-DECLINED" |
"OFFER-ACCEPTED" |
"INITIATED" |
"ACCEPT" |
"REJECT" |
"JOB-APPLIED" |
"OFFERED" |
"INTERVIEW-ACCEPTED" |
"INTERVIEW-REJECTED" |
"CANDIDATE-WITHDRAWN" | "ACTIVE" | "INACTIVE" |
"INTERVIEW-FAILED" | "ACCEPTED" | "REJECTED" |
"OFFER WITHDRAWN" |
"OFFER DECLINED"|
"ON HOLD" |
"FILLED" |
"CLOSED"|
"CANDIDATE BACKOUT" |
"RESUME-PENDING" |
"BLOCKED" |
"DRAFTED"|
"SUBMITTED" |
"CANDIDATE-SUBMITTED" |
"SELECTED" |
"APPLICATION-REJECTED" |
"CANDIDATE-REJECTED" |
"UNAVAILABLE";

@Injectable({
  providedIn: "root",
})
export class GigsumoService {

  ref: any;
  buttonClicked: boolean = true;
  planUpdatedTo: string = null;
  jobCandidateCountUpdatedTo: string = null;
  candidateInviteBtnClicked: boolean = false;
  private profilePhotoSource = new BehaviorSubject<string | null>(null);
  currentProfilePhoto = this.profilePhotoSource.asObservable();
  updateProfilePhoto(photoUrl: string) {
    this.profilePhotoSource.next(photoUrl);
  }

  static  FILTER_ITEMS(d = "JOB") {
    return d === "JOB" ?  [
      {
        value : "TA Managers Network",
        key : "mtaNetworkJobs"
      },
      {
        value : "Freelance Recruiter Network",
        key : "freeLancerNetworkJobs"
      },
      {
        value : "Recruiter Network",
        key : "recruiterNetworkJobs"
      },
      {
        value : "Job Seeker Network",
        key : "jobSeekerNetworkCandidates"
      },
      {
        value : "Bench Sales Network",
        key : "benchNetworkCandidates"
      },
    ] :  [
      {
        value : "TA Managers Network",
        key : "mtaNetworkCandidates"
      },
      {
        value : "Freelance Recruiter Network",
        key : "freeLancerNetworkCandidates"
      },
      {
        value : "Job Seeker Network",
        key : "jobSeekerNetworkCandidates"
      },
      {
        value : "Bench Sales Network",
        key : "benchNetworkCandidates"
      },
    ];
  }

  constructor(private api: ApiService) { }
  readonly swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton: 'btn btn-success',
      cancelButton: 'btn btn-danger'
    },
    buttonsStyling: false
  });

  readonly userType = localStorage.getItem('userType');
  readonly userId = localStorage.getItem('userId');

  get PROFILEDETAILS(): Observable<any> {
    const data: { userId: string; userType: string } = {
      userType: localStorage.getItem("userType"),
      userId: localStorage.getItem("userId"),
    };
    return this.api.create("user/profileDetails", data);
  }

  get FINDBYLIST(): Observable<any> {
    let data = { "domain": "CLIENT_TYPE,JOB_CLIENT_TYPES,PAY_TYPE,GIGSUMO_JOB_TITLE,GIGSUMO_RECRUITERS_TITLE_LIST" }
    return this.api.create('listvalue/findbyList', data);
  }

  getUsaCities(value: string): Observable<any> {
    let data: { countryCode: string, zipCode: string } = {
      countryCode: "US",
      zipCode: value
    }
    return this.api.create("country/geodetails", data);
  }
  getBusinessId(userId: string): Observable<any> {
    return this.api.query(`business/findUserRoleInBusiness/${userId}`)
  }

  // In-flight cache: dedupes concurrent callers so only one
  // `business/findUserRoleInBusiness/{userId}` request goes out per session
  // bootstrap. Cleared on error so a retry can fire next time.
  private myBusinessIdInFlight$: Observable<string> | null = null;

  /**
   * Resolves the user's own businessId — from localStorage if cached, else
   * from the backend (and writes it to localStorage as a side effect).
   *
   * Returns an Observable so callers that need the value before firing
   * their own API calls (e.g. dashboard payloads keyed on `myBusinessId`)
   * can `subscribe`/chain on it. Legacy fire-and-forget call sites still
   * trigger the load via the eager internal subscribe below — they just
   * don't await the result.
   */
  loadMyBusinessId(): Observable<string> {
    const cached = localStorage.getItem('myBusinessId');
    if (cached) {
      return of(cached);
    }
    const userId = localStorage.getItem('userId');
    if (!userId) {
      return of('');
    }
    if (!this.myBusinessIdInFlight$) {
      this.myBusinessIdInFlight$ = this.getBusinessId(userId).pipe(
        map((res: any) => {
          const id = (res?.code === '00000' && res?.data?.businessData?.businessId)
            ? res.data.businessData.businessId
            : '';
          if (id) {
            localStorage.setItem('myBusinessId', id);
          }
          return id;
        }),
        shareReplay(1)
      );
      // Eager subscribe so the side effect (localStorage write) still fires
      // for the legacy call sites that don't subscribe to the returned
      // Observable. `shareReplay(1)` lets a real subscriber later receive
      // the same value without re-firing the request.
      this.myBusinessIdInFlight$.subscribe({
        error: () => { this.myBusinessIdInFlight$ = null; }
      });
    }
    return this.myBusinessIdInFlight$;
  }

  isSuperAdmin(data: Partial<superAdminDetails>) {
    return this.api.query(`business/checkBusinessStatus/${data.userId}/${data.organisationId}`);
  }

  checkBusinessByDomain(email: string) {
    return this.api.create(`business/checkBusinessByDomain/${email}`,{});
  }

  get USERDETAILS(): Observable<any> {
    return this.api.query("user/" + this.userId);
  }


  getText(){
    const plan = localStorage.getItem("MemberShipType");
    return plan === "Free" ? 
    "Please, note that all the posting under the current organization will be marked for deletion. Do you want to proceed ?" : "You have active jobs/candidates associated for the current organization. All records will be reassigned to the business, and you will not have access to these. Do you want to proceed with the changes?";
  }


  getResponseMessage(code: string, content?: any): Promise<SweetAlertResult> {
    switch (code) {


      case "OTP_SUCCESSFULLY_VERIFIED":
        return this.swalMessage({
          icon: "success",
          title: "Work Experience saved successfully",
          showConfirmButton: false,
          timer: 2000,
        });
        break;
      case GigsumoConstants.SUCESSCODE:
        return this.swalMessage({
          icon: "success",
          title: "Work Experience saved successfully",
          showConfirmButton: false,
          timer: 2000,
        });
        break;
      // case "EMAIL_DOMAIN_MATCHES_BUSINESS_ORGANISATION" :
      // return this.swalMessage({
      //   icon: "success",
      //   title: "Business email matches business organisation",
      //   text: "Now, that your email address matched with your business organisation, please authenticate your business email.",
      //   showConfirmButton: true,
      // });
      // break;
      case "NO_BUSINESS_FOUND_FOR_EMAIL":
        return this.swalMessage({
          icon: "info",
          title: "Pro Tip",
          text: "There are no business pages found against your email address. Therefore, you may create business page for your business email and enjoy a great deal of benefits. Please, authenticate the email first.",
          showConfirmButton: true,
        });
        break;

      case GigsumoConstants.CHANGING_CURRENORG:
        return this.swalWithButtons({
          title:  ` ${content === 'change' ? 'Leaving' : 'Deleting'} current organization`,
          text: this.getText(),
          icon: 'info',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          reverseButtons: true
        });
        break;
      case "DELTING_CURRENT_ORGANIZATION":
        return this.swalWithButtons({
          title: 'Deleting current organization',
          text: this.getText(),
          icon: 'info',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          reverseButtons: true
        });
        break;
      case GigsumoConstants.NO_ADMIN_BUSINESS_FOUND: case GigsumoConstants.NO_BUSINESS:
        return this.swalWithButtons({
          title: 'info',
          text: this.getText(),
          icon: 'info',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          reverseButtons: true
        });
        break;
      case GigsumoConstants.CURRENTORGANIZATION_NEED:
        return this.swalMessage({
          title: "Oops..",
          text: "Sorry, one current organization is at least needed for your user type.",
          icon: "error",
          confirmButtonText: "Ok",
        })
        break;
      case GigsumoConstants.SUPERADMIN_BUSINESS_NO_MEMBERS:
        return this.swalWithButtons({
          title: `Deactivate Business Page`,
          text: `You are the super admin of the current organization business page. Please deactivate the business page before ${content != "changing" ? "deleting" : "changing"} your current organization.`,

          icon: "info",
          showCancelButton: true,
          confirmButtonText: "Ok",
          cancelButtonText: "Cancel",
          reverseButtons: true
        });
        break;
      case GigsumoConstants.SUPERADMIN_BUSINESS_HAS_MEMBERS: case "DEACTIVATED_BUSINESS":
        return this.swalMessage({
          text: `You are the super admin of the business page '${content}'. You have to transfer your super admin rights to other members before ${code === "DEACTIVATED_BUSINESS" ? "deactivating the business page": "changing your current organization"}.`,
          title: "Transfer your super admin rights",
          icon: "info",
          showCancelButton: true,
          confirmButtonText: "Ok",
          cancelButtonText: "Cancel",
          reverseButtons: true
        });
        break;
      case GigsumoConstants.FAILURECODE:
        return this.swalMessage({
          text: "Oops! Something went wrong!",
          icon: 'info'
        })
        break;
      case "DELETE":
        return this.swalWithButtons({
          title: "Delete your Work Experience?",
          text: "Are you sure you wish to delete this work Experience ? It cannot be reversed. ",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          reverseButtons: true,
        });
        break;
      case "MAKECURRENT":
        return this.swalWithButtons({
          title: 'Oops..',
          text: "Looks Like you don't have any Current Organization",
          icon: 'info',
          confirmButtonText: 'Ok',
          showCancelButton: true,
          cancelButtonText: "Cancel",
          reverseButtons: true,
        })
        break;
      case "AREYOUSURE":
        return this.swalWithButtons({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          reverseButtons: true,
        });
        break;
      case "CANCELEMAILAUTHENTICATION":
        return this.swalWithButtons({
          title: "Cancelling Email Verification",
          text: "You won't be able be to change the current organisation if you skip this step. Would you like to proceed?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          reverseButtons: true,
        });
        break;
      case "CHANGEPROFILE":
        return this.swalWithButtons({
          title: "Are you sure you want to change?",
          text: "There is a workplace you have chosen already to show on Profile. Would you like to change it?",
          icon: "info",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          reverseButtons: true,
        });
        break;
      case "CHANGING_CLIENT_TYPE":
        return this.swalWithButtons({
          title: 'Alert',
          text: "Please, note that the current organisation type is updated.",
          icon: 'info',
          showCancelButton: true,
          confirmButtonText: "Proceed",
          cancelButtonText: "Cancel",
          reverseButtons: true,
        });
        break;
      case "TWO_SAME_CURRENTORGANIZATION":
        return this.swalWithButtons({
          title: "Two Current Organization Detected.",
          text: "Sorry, you can't have two current organization under the same business organization.",
          icon: "info"
        });
        break;
      case "CHECK_EMAIL_DOMAIN_AGAINST_BUSINESS_ORGANISATION":
        return this.swalWithButtons({
          title: "Business Organisation Mismatches Email Domain",
          // text: "The provided business email address seems like it is linked to the business page " + "'" + content + "'" + ", which is not your new current organisation. With mismatching email address and current organisation details, you shall not become an employee of the business page.",
          text: "The email domain associated with the business page " + "'" + content + "'" + " does not match your current organization. Therefore, you cannot be listed as an employee of this business page, Please check your credentials",
          icon: "info",
          // showCancelButton: true,
          confirmButtonText: "Ok",
          // cancelButtonText: "Cancel",
          reverseButtons: true,
        });
        break;
      case "WORK_EXPERIENCE_HAS_BUSINESS_BUT_EMAIL_DOESNOT":
        return this.swalWithButtons({
          title: "Provided Email Doesn't Have A Business But Your Work Experience Does",
          text: "The provided business email address does not have a business page, however your work experience is linked to the business page " + "'" + content + "'" + ". With mismatching email address and current organisation details, you shall not become an employee of the business page.",
          icon: "info",
          showCancelButton: true,
          cancelButtonText: "Go Back",
          showConfirmButton : false
        });
        break;
      case "BUSINESS_EXIST_WITH_DOMAIN":
        return this.swalWithButtons({
          title: "Business Already exists",
          text: "There is already an organization with a business page associated with your email domain. Are you sure you dont want to use that organization? You will not be able to create a business page. Do you wish to continue ?",
          icon: "info",
          showCancelButton: true,
          confirmButtonText: "yes",
          cancelButtonText: "Cancel",
          reverseButtons: true,
        });
        break;
      case "OTP_VERIFIED":
        return this.swalMessage({
          title: "Otp Verified Sucessfully",
          icon: "success",
          text: "Your secondary Email is added Sucessfully!.",
          timer: 1000
        })
        break;
      default:
        break;
    }
  }

  getFilterELement(type : "JOB" | "CANDIDATE" , userId : string){
    return this.api.query(`business/findNetworksForFilter?userId=${userId}&type=${type}`).pipe(
      map(response => {
        if (response != null) {
          if (response.code && response.code != GigsumoConstants.SUCESSCODE) {
            throw new Error("There is some issue with Server");
          }
          return response;
        }
      })
    )
  }
   formatLocation(city: string, state: string, country: string): string {
    if (city || state || country) {
      const locationParts = [city, state, country].filter(part => part);
      return locationParts.join(', ');
    }
    return '';
  }

  async getFilterPayload(type: "JOB" | "CANDIDATE", userId: string) {
    try {
      const response = await lastValueFrom(this.api.query(`business/findNetworksForFilter?userId=${userId}&type=${type}`));

      if (response != null && response.code && response.code !== GigsumoConstants.SUCESSCODE) {
        throw new Error("There is some issue with Server");
      }

      return response;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  public colorClass: string[] = ['fa fa-circle font-9 icon-prime-color',
    'fa fa-circle font-9 icon-red-color',
    'fa fa-circle font-9 icon-blue-color',
    'fa fa-circle font-9 icon-saffron-color',
    'fa fa-circle font-9 icon-prime-color',
    'fa fa-circle font-9 icon-green-color',
    'fa fa-circle font-9 icon-orange-color',
    'fa fa-circle font-9 icon-yellow-color',
    'fa fa-circle font-9 icon-red-color',
    'fa fa-circle font-9 icon-blue-color',
    'fa fa-circle font-9 icon-orange-color',
    'fa fa-circle font-9 icon-red-color',
    'fa fa-circle font-9 icon-green-color',
    'fa fa-circle font-9 icon-saffron-color',
    'fa fa-circle font-9 icon-prime-color',
    'fa fa-circle font-9 icon-blue-color',
    'fa fa-circle font-9 icon-orange-color',
    'fa fa-circle font-9 icon-yellow-color',
    'fa fa-circle font-9 icon-red-color',
    'fa fa-circle font-9 icon-green-color',
    'fa fa-circle font-9 icon-orange-color',
    'fa fa-circle font-9 icon-red-color',
    'fa fa-circle font-9 icon-blue-color',
    'fa fa-circle font-9 icon-saffron-color',
    'fa fa-circle font-9 icon-prime-color',
    'fa fa-circle font-9 icon-green-color',
    'fa fa-circle font-9 icon-orange-color',
    'fa fa-circle font-9 icon-yellow-color',
    'fa fa-circle font-9 icon-red-color',
    'fa fa-circle font-9 icon-blue-color',
    'fa fa-circle font-9 icon-orange-color',
    'fa fa-circle font-9 icon-red-color',
    'fa fa-circle font-9 icon-green-color',
    'fa fa-circle font-9 icon-saffron-color',
    'fa fa-circle font-9 icon-prime-color',
    'fa fa-circle font-9 icon-blue-color',
    'fa fa-circle font-9 icon-orange-color',
    'fa fa-circle font-9 icon-yellow-color',
    'fa fa-circle font-9 icon-red-color',
    'fa fa-circle font-9 icon-green-color',
    'fa fa-circle font-9 icon-orange-color',
    'fa fa-circle font-9 icon-red-color',
    'fa fa-circle font-9 icon-blue-color',
    'fa fa-circle font-9 icon-saffron-color'];


  private swalMessage(data: SweetAlertOptions): Promise<any> {
    return Swal.fire(data);
  }

  private swalWithButtons(data: SweetAlertOptions): Promise<any> {
    return this.swalWithBootstrapButtons.fire(data);
  }


  isNullOrEmptyList(array: Array<any>): boolean {
    return array == null || array.length == 0;

  }

  isNullOrEmptyString(string: string): boolean {
    return string == null || string.trim().length == 0;

  }

  private userData : Array<any> = [];
  setUserData(v) : void{
    this.userData = v;
  }

  getUserData() : Array<any>{
   return this.userData;
  }
  openView(title : string , data : any[] , modalService : BsModalService){

    const modalData: any = {
      backdrop: 'static',
      keyboard: false,
      size: "lg",
    };

    // this.ref = modalService.show(ModalPopupComponent, modalData);
    this.ref.componentInstance.title = title;
    this.ref.componentInstance.fields = data;
}


curryObject(obj : any , key1 : string){
  return (key2 : string) =>{
    return obj[key1][key2];
  }
}
isSelected(networkId: number, selectedNetworks: number[]): boolean {
  // Ensure selectedNetworks is a valid array
  return Array.isArray(selectedNetworks) && selectedNetworks.includes(networkId);
}


createScrollPagination(response : any , current : Array<any> , previous : Array<any> , data : any){

  let pageObj = {
    combinedArr : [],
    stopScroll : false,
    prevSearchAfterKey : null,
    searchAfterKey : null,
  }

  pageObj.combinedArr = current.concat(previous);

  if(response.data.search)


  return pageObj;
}

removeDuplicatesKey(arr , key : string){
  return arr.filter((item, index, self) =>
    index === self.findIndex((t) => t[key] === item[key])
  )
}


  onCheckboxChange(
    networkId: number,
    checked: boolean,
    selectedNetworks: number[],
    formGroup: FormGroup,
    controlName: string
  ): number[] {
    if (checked) {
      if (!selectedNetworks.includes(networkId)) {
        selectedNetworks.push(networkId);
      }
    } else {
      selectedNetworks = selectedNetworks.filter((id) => id !== networkId);
    }

    // Update the form control value
    formGroup.controls[controlName].setValue(selectedNetworks);
    return selectedNetworks;
  }

  updatePublishedBy(object : any, response){
    if(response.code === GigsumoConstants.SUCESSCODE){
      const users = response.data.connectionsList;
      const retainUser = response.data.usersToRetain;
      const searchKey = response.data.searchAfterKey;

      if (users) {
        const current = users;
        const exist = object.publishedByList.getValue();
        if(object.publishedByPrevSelectedValue && object.publishedByPrevSelectedValue.length > 0){
          if(retainUser === undefined){
            object.publishedByPrevSelectedValue = [];
          }
          else if(retainUser){
            object.publishedByPrevSelectedValue = object.publishedByPrevSelectedValue.filter(x => retainUser.includes(x.userId));
          }
          object.selectedPublishedBy = object.publishedByPrevSelectedValue.map(x => x.userId);
          object.publishedByCount = object.publishedByPrevSelectedValue ? object.publishedByPrevSelectedValue.length : 0;
        }
        let data = (object.publishedByPrevSelectedValue &&
        object.publishedByPrevSelectedValue.length > 0) ? exist.concat(object.publishedByPrevSelectedValue)
        : exist;

        let finalData = this.removeDuplicatesKey([...data, ...current] , 'userId');
        object.publishedByList.next(finalData);
      }

      if (
        users != null && (users.length === 0 || JSON.stringify(object.publishedByPrevSearchAfterKey) ===  JSON.stringify(searchKey))
      ) {
        object.publishedByStopScroll = true;
      }

      if((users && users.length === 0) && (retainUser && retainUser.length === 0)){
        object.publishedByCount = 0
        object.selectedPublishedBy = [];
      }

      object.publishedByPrevSearchAfterKey = searchKey;
    }
  }


  updateBusinessCustomers(object : any, response : any) {


    if(response.code === GigsumoConstants.SUCESSCODE){
      // object.isLoading = true;
      const users = response.data.businessDetails;
      const retainUser = response.data.businessesToRetain;
      const searchKey = response.data.searchAfterKey;

      if (users) {
        const current = users;
        const exist = object.customersList.getValue();
        if(object.customerPrevSelectedValue && object.customerPrevSelectedValue.length > 0){
          if(retainUser === undefined){
            object.customerPrevSelectedValue = [];
          }
          else if(retainUser){
          object.customerPrevSelectedValue = object.customerPrevSelectedValue.filter(x => retainUser.includes(x.businessId));
          }
          object.selectedCustomers = object.customerPrevSelectedValue.map(x => x.businessId);
          object.customerCount = object.customerPrevSelectedValue ? object.customerPrevSelectedValue.length : 0;
        }
        let data = (object.customerPrevSelectedValue  &&
        object.customerPrevSelectedValue.length > 0) ? exist.concat(object.customerPrevSelectedValue)
        : exist;

        let finalData = this.removeDuplicatesKey([...data, ...current] , 'businessId');
        object.customersList.next(finalData);
      }

      if (
        users != null && (users.length === 0 || JSON.stringify(object.customersPrevSearchAfterKey) ===  JSON.stringify(searchKey))
      ) {
        object.customersStopScroll = true;
      }

      if((users && users.length === 0) && (retainUser && retainUser.length === 0)){
        object.customerCount = 0;
        object.selectedCustomers  = [];
      }

      object.customersPrevSearchAfterKey = searchKey;

     }


  }
  private cache = new Map<string, BehaviorSubject<any>>();
  // When each cached community was last fetched. Without it the Map lived for the whole
  // session, so anyone who was not the person doing the editing — a member, an employee,
  // a second tab — kept the old logo and name until they refreshed the page.
  private cacheFetchedAt = new Map<string, number>();
  private readonly COMMUNITY_CACHE_TTL = 5 * 60 * 1000; // 5 minutes

  getCommunityDetails(communityId: string): Observable<any> {
    if (!this.cache.has(communityId)) {
      this.cache.set(communityId, new BehaviorSubject<any>(null));
      this.fetchCommunityDetails(communityId);
    } else if (this.isCommunityCacheStale(communityId)) {
      // Refresh in the background. The subject keeps replaying the value it already
      // holds, so callers see no gap and simply receive the newer value when it lands.
      this.fetchCommunityDetails(communityId);
    }
    return this.cache.get(communityId)!.asObservable().pipe(shareReplay(1));
  }

  private isCommunityCacheStale(communityId: string): boolean {
    const fetchedAt = this.cacheFetchedAt.get(communityId);
    return !fetchedAt || (Date.now() - fetchedAt) >= this.COMMUNITY_CACHE_TTL;
  }

  private fetchCommunityDetails(communityId: string) {
    // Stamped before the request goes out so reads arriving while it is in flight
    // don't queue duplicate fetches. Left in place on failure too, so a broken
    // endpoint is retried on the next expiry rather than on every single read.
    this.cacheFetchedAt.set(communityId, Date.now());
    this.api.query(`community/details/${communityId}`).subscribe(
      (res: any) => {
        if (this.cache.has(communityId)) {
          this.cache.get(communityId)!.next(res.data?.communityDetails);
        }
      },
      (err) => {
        console.error("Error fetching community details", err);
      }
    );
  }
  // A community's details are cached here for the lifetime of this singleton, and
  // getCommunityDetails() only hits the network when the key is missing — so after a
  // `community/update` the feed kept replaying the old logo (and the old name) until a
  // full page refresh recreated the service. Drop just the one community's entry so the
  // next lookup refetches; clearCache() below stays reserved for logout.
  invalidateCommunityDetails(communityId: any) {
    if (communityId === null || communityId === undefined || communityId === "") {
      return;
    }
    this.cache.delete(communityId);
    this.cacheFetchedAt.delete(communityId);
    // The key is whatever the caller handed getCommunityDetails(), so delete the string
    // form too rather than trust the declared type.
    this.cache.delete(String(communityId));
    this.cacheFetchedAt.delete(String(communityId));
  }

  clearCache() {
    this.cache.clear(); // Remove all stored community details
    this.cacheFetchedAt.clear();
  }

  getFormattedCurrentDate(): string {
    const now = new Date();
    return now.getFullYear() + "-" +
      String(now.getMonth() + 1).padStart(2, "0") + "-" +
      String(now.getDate()).padStart(2, "0") + "T" +
      String(now.getHours()).padStart(2, "0") + ":" +
      String(now.getMinutes()).padStart(2, "0") + ":" +
      String(now.getSeconds()).padStart(2, "0") + "." +
      String(now.getMilliseconds()).padStart(3, "0") + "+0000";
  }

}
